import { gql } from "@apollo/client";
import { ReceiptTemplateTypeNoNestingFragment } from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { ReceiptTemplateType as ReceiptTemplateTypeEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import ReceiptTemplateType from "../../data/model/ReceiptTemplateType";
import { EntityResourceDefinition } from "../entity-resource-definition";
import { SyncProgressStatus } from "../page-query";

const receiptTemplateTypesQuery = gql`
  ${ReceiptTemplateTypeNoNestingFragment}
  query GetReceiptTemplates($filters: ReceiptTemplatesListFilterOptions) {
    receiptTemplateTypes(filters: $filters) {
      ...ReceiptTemplateTypeNoNesting
    }
  }
`;

export const receiptTemplateTypeDefinition = new EntityResourceDefinition<
  ReceiptTemplateTypeEntity,
  ReceiptTemplateType
>({
  entity: "receipt_template_type",
  query: receiptTemplateTypesQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.html = fetchedEntity.html || "";
    newEntity.css = fetchedEntity.css;
  },
  fetchEntities: async (options) => {
    return client
      .query({
        query: receiptTemplateTypesQuery,
        variables: {
          filters: {
            updatedAt: options?.after,
          },
        },
      })
      .then(async (res) => {
        const progressCallback = options?.progressCallback;

        await progressCallback?.({
          fetched: res.data.receiptTemplateTypes.length,
          estimatedTotalItems: res.data.receiptTemplateTypes.length,
          status: SyncProgressStatus.FETCHING,
          totalItems: res.data.receiptTemplateTypes.length,
        });

        return res.data.receiptTemplateTypes;
      });
  },
});
